export default "__VITE_ASSET__DiJh64L2__"